import { render } from "./BackerCenterPendingActionsSlider.vue?vue&type=template&id=e47833ba"
import script from "./BackerCenterPendingActionsSlider.vue?vue&type=script&lang=js"
export * from "./BackerCenterPendingActionsSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__